export enum StorageTypeEnum {
  S3,
  Link
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/UploadDocument/StorageTypeEnum.ts